import { type ObjectValuesUnionType } from '../utils/typing';

import { SportIds } from './sports';

export const MatchStatuses = Object.freeze({
  PREMATCH: 'prematch',
  LIVE: 'live',
  ENDED: 'ended',
  CANCELLED: 'cancelled',
});

export type MatchStatus = ObjectValuesUnionType<typeof MatchStatuses>;

export const ScoringTeams = Object.freeze({
  HOME: 'home',
  AWAY: 'away',
});

export type ScoringTeam = ObjectValuesUnionType<typeof ScoringTeams>;

export const RugbyScorerTypes = Object.freeze({
  CONVERSION: 'conversion',
  DROP: 'drop_goal',
  TRY: 'try',
  PENALTY: 'penalty',
  PENALTY_TRY: 'penalty_try',
});

export type RugbyScorerType = ObjectValuesUnionType<typeof RugbyScorerTypes>;

export type Scorer = {
  score1: number;
  score2: number;
  player: string;
  playerId: number;
  scoringTeam: ScoringTeam;
  ownGoal?: boolean;
  time: number;
  type?: RugbyScorerType;
};

export type MatchScore = {
  score1: number | null;
  score2: number | null;
};

export const TvChannels = Object.freeze({
  WINAMAXTV: 'WINAMAXTV',
});

export type TvChannel = ObjectValuesUnionType<typeof TvChannels>;

export type Highlight = {
  stream: string;
  eventType: {
    name: string;
  };
};

export const MatchTitleAllowedSportIdsAnimation = [
  SportIds.SOCCER,
  SportIds.RUGBY,
  SportIds.RUGBY_LEAGUE,
  SportIds.ICEHOCKEY,
];

export const SportIdsScoreboardWithIcons = [SportIds.RUGBY, SportIds.RUGBY_LEAGUE];
